import type { FaireProductEntity } from "../../entity_types/product";

export const p_9k8tg3hkgd: FaireProductEntity = {
  token: "p_9k8tg3hkgd",
  type: "product",
  name: "Cunt Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/5232565bc33a661665bb5cc8f6be3439c8b7562756f0f30c6b3344e52ce6ccb5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/df7d46190f9eefd2035a3b88a1e09dbd34108b5eba7307a4248665c898f2846b.jpeg",
    "https://cdn.faire.com/fastly/d6c8d2731902c6d6d4a78d8fc0f5a460906a8b838f49727e3fec58a172821f77.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/4d72a86b8d6011bc6fd4778d855f1bfb73362fd0d9ec46634ddfc9e10863e401.jpeg",
    "https://cdn.faire.com/fastly/c8db4e538d8bfbf311c4332ecb84d8c0a4924f56979ffa33d0adfb025d69314b.jpeg",
    "https://cdn.faire.com/fastly/0433e3e6683da9b7bc4c56c316f61af72132723b5e99968ed63ecfd2a030c083.jpeg",
    "https://cdn.faire.com/fastly/f918f9fa0100dd2470849d202d557fac00e1e4309f90541f11d2dedb07487c8b.jpeg",
    "https://cdn.faire.com/fastly/2e57b48e775490617bcd376334b5f944469b56a0b04dfd401bf4acf4900a8299.jpeg"
  ],
  priceDollars: 6.75,
  description: "Sometimes all it takes is a single word to let the world know what's up. No matter how you're feeling day-to-day, these socks are always serving what we all feel deep within. ✨\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:53.650Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
